import PageHeadingContainer from './PageHeadingContainer'

export default PageHeadingContainer
